import React, { Component, Fragment } from "react";
import moment from "moment";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as ReportsActions,
  Selectors as ReportsSelectors,
} from "store/ducks/reports";

import { Access } from "common";
import { Page, Breadcrumbs, Panel, Loading } from "components";
import { Filters } from "./components";

const INITIAL_STATE = {
  date_start: null,
  date_end: null,
  plans: [],
  date_formatted: "",
  place_formatted: "Todas",
  channels: [],
};

class Benefits extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Relatórios", to: "/reports" },
      { name: "Relatório de ticket médio e faturamento ", to: "" },
    ],
    filter: {
      ...INITIAL_STATE,
      place_id: Access.lockedStore()
        ? Access.lockedStore(true)
        : { value: "", label: "Todas" },
    },
  };

  componentDidMount() {
    const { getReportTicketsRequest } = this.props;

    getReportTicketsRequest(this.state.filter);
  }

  componentDidUpdate(oldProps, oldState) {
    const { filter } = this.state;

    if (
      oldState.filter.date_start !== filter.date_start ||
      oldState.filter.date_end !== filter.date_end
    ) {
      const date_formatted = filter.date_start
        ? `${
            filter.date_start !== null
              ? moment(filter.date_start).format("DD/MM/YYYY")
              : ""
          } ${filter.date_end !== null ? "-" : ""} ${
            filter.date_end !== null
              ? moment(filter.date_end).format("DD/MM/YYYY")
              : ""
          }`
        : "";

      this.setState({ filter: { ...filter, date_formatted } });
    }

    if (oldState.filter.place_id !== filter.place_id) {
      const place_formatted = filter.place_id.label;

      this.setState({ filter: { ...filter, place_formatted } });
    }
  }

  handleChangeFilter = async (name, value) => {
    const { filter } = this.state;
    const { getReportTicketsRequest } = this.props;

    this.setState({ filter: { ...filter, [name]: value } }, () => {
      getReportTicketsRequest(this.state.filter);
    });
  };

  handleCleanFilter = async (e) => {
    e.preventDefault();

    const { getReportTicketsRequest } = this.props;

    const newState = {
      filter: {
        ...INITIAL_STATE,
        place_id: Access.lockedStore()
          ? Access.lockedStore(true)
          : { value: "", label: "Todas" },
      },
    };

    this.setState(newState, () => {
      getReportTicketsRequest(this.state.filter);
    });
  };

  handleExport = () => {
    const { filter } = this.state;
    const { exportReportTicketsRequest } = this.props;

    exportReportTicketsRequest(filter);
  };

  render() {
    const { breadcrumbs, filter } = this.state;
    const { report } = this.props;

    return (
      <Page className="page-reports">
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <header className="page-reports-header">
          <Page.Title>Relatório de ticket médio e faturamento</Page.Title>

          <Filters
            data={filter}
            onChange={this.handleChangeFilter}
            onClean={this.handleCleanFilter}
          />
        </header>

        <Panel className="panel-list">
          <Fragment>
            {report.loading && <Loading type="table" size="x-large" />}

            {filter.date_formatted !== "" && (
              <Panel.Title>
                Período: <span>{filter.date_formatted}</span>
              </Panel.Title>
            )}

            {filter.place_formatted !== "" && (
              <Panel.Title>
                Loja: <span>{filter.place_formatted}</span>
              </Panel.Title>
            )}

            <h5>Relatório de ticket médio e faturamento</h5>

            <table className="contact-table table table-curved">
              <thead>
                <tr>
                  <th>Ticket médio e faturamento</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Ticket médio</td>
                  <td className="number-report">
                    R$ {report.data.average_ticket}
                  </td>
                </tr>
                <tr>
                  <td>Clientes ativos</td>
                  <td className="number-report">
                    {report.data.active_members}
                  </td>
                </tr>
                <tr>
                  <td>Compras efetuadas</td>
                  <td className="number-report">
                    {report.data.total_checkouts}
                  </td>
                </tr>
                <tr>
                  <td>Faturamento total</td>
                  <td className="number-report">
                    R$ {report.data.amount_checkouts}
                  </td>
                </tr>
              </tbody>
            </table>

            <button className="button-submit" onClick={this.handleExport}>
              Exportar Planilha
            </button>
          </Fragment>
        </Panel>
      </Page>
    );
  }
}

const mapState = (state) => ({
  report: {
    ...state.reports.tickets,
    data: ReportsSelectors.tickets(state.reports.tickets.data),
  },
});

const mapActions = (dispatch) => bindActionCreators(ReportsActions, dispatch);

export default connect(mapState, mapActions)(Benefits);
